import React, { useEffect, useState } from "react";
import TrainerListIndex from "./TrainerListIndex";
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const TrainerListLanding = () => {
    const [loginId, setLoginId] = useState('');

    useEffect(() => {
        let id = localStorage.getItem("userId");
        setLoginId(id);
    }, []);

    console.log(loginId !== '' ? "heeeeeeeeeeeeeeeeeeee" : "meeeeeeeeeeeeeeeeeeee");

    return (
        <>
            {loginId !== '' ? (
                <>
                    <IdleTimeOutHandler />
                    <TrainerListIndex />
                    {console.log("Inside <IdleTimeOutHandler /> and <TrainerListIndex /> block")}
                </>
            ) : (
                <>
                    <TrainerListIndex />
                    {console.log("Inside <TrainerListIndex /> block")}
                </>
            )}
        </>
    )
}

export default TrainerListLanding;
